import { useQuery } from '@tanstack/react-query';

import { endpoints, publicFetcher } from 'src/utils/axios';

import { queryKeys } from 'src/react-query/constants';

import { IAgencyBranding } from 'src/types/portal';

// ----------------------------------------------------------------------

// The success body is the Ardalis.Result envelope; unwrap `value` when present
// so the hook works regardless of whether the API exposes the raw DTO or the envelope.
function unwrap(raw: any): IAgencyBranding {
  if (raw && typeof raw === 'object' && 'value' in raw && 'isSuccess' in raw) {
    return raw.value as IAgencyBranding;
  }
  return raw as IAgencyBranding;
}

export function useGetAgencyBranding(slug?: string) {
  const {
    data: branding,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [queryKeys.agencyBranding, slug],
    queryFn: async () => unwrap(await publicFetcher(endpoints.portal.branding(slug as string))),
    enabled: Boolean(slug),
    retry: false,
    staleTime: 300000,
    refetchOnWindowFocus: false,
  });

  return { branding, isLoading, isError };
}
